import { Component, Input } from '@angular/core';
import { TextType } from '../../models/text-type.model';

@Component({
    selector: 'amdb-text-type-display',
    templateUrl: './text-type-display.component.html',
    styleUrls: ['./text-type-display.component.scss'],
})
export class TextTypeDisplayComponent {
    @Input() textTypeEntries: TextType[];
}
